/* Optional, template-declared PDP plugin. The native host still owns its renderer,
 * form, controller and commerce; the selector sidecar owns case presentation/handoff. */
(function (root) {
  'use strict';
  var document = root.document;
  if (!document) return;
  var registry = root.PzPdpPlugins || (root.PzPdpPlugins = Object.create(null));
  if (Object.prototype.hasOwnProperty.call(registry, 'case-selector')) return;
  var excludedMounts = new WeakSet();

  function blocksFor(mount) {
    var section = mount && mount.closest && mount.closest('section[data-section]');
    return section ? section.querySelectorAll('sc-case-selector') : [];
  }
  function assetsReady() {
    return !!(root.ScCaseSelector && typeof root.ScCaseSelector.prepare === 'function'
      && root.ScCaseSelectorCore && typeof root.ScCaseSelectorCore.assertCompatible === 'function');
  }
  // The head prehide (snippets/sc-case-selector-prehide.liquid) gave the native form back before the selector bound:
  // one-way, so the page behaves like Edit/restore and the native form owns the purchase.
  function failedOpen() {
    return !!(document.documentElement && document.documentElement.hasAttribute('data-sc-case-failopen'));
  }
  function excluded(cfg) {
    return failedOpen() || !!(cfg && (cfg.editMode || cfg.restoreMode || cfg.rawRestoreIntent || cfg.restoreStateId));
  }
  function emit(type) {
    // No selection, controller, release or shopper data crosses the public event seam.
    document.dispatchEvent(new root.CustomEvent(type));
  }
  function pending(bootstrapController) {
    var mount = bootstrapController && bootstrapController.mount;
    if (failedOpen() || (mount && excludedMounts.has(mount))) return false;
    var blocks = blocksFor(mount);
    if (!blocks.length) return true; // Declared plugin cannot sell before its block parses.
    if (blocks.length !== 1) return true;
    if (blocks[0].getAttribute('data-sc-case-excluded') === 'true') return false;
    return !assetsReady()
      || ['snap', 'tough', 'magsafe'].indexOf(blocks[0].getAttribute('data-sc-case-selected')) === -1;
  }
  function ready(args) {
    var blocks = blocksFor(args.mount);
    if (excluded(args.cfg)) {
      excludedMounts.add(args.mount);
      var changed = false;
      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].getAttribute('data-sc-case-excluded') !== 'true') {
          blocks[i].setAttribute('data-sc-case-excluded', 'true');
          changed = true;
        }
      }
      if (changed) emit('pz:plugin-change');
      return true;
    }
    excludedMounts.delete(args.mount);
    for (var j = 0; j < blocks.length; j++) blocks[j].removeAttribute('data-sc-case-excluded');
    return blocks.length === 1 && assetsReady();
  }
  function prepare(args) {
    if (excluded(args.cfg)) return null;
    if (blocksFor(args.mount).length !== 1 || !assetsReady()) throw new Error('Case selection unavailable');
    // From here only the selector decides about the native fields (the head prehide no longer fails open);
    // set before prepare so a PZ error during attach cannot reveal then re-hide them.
    var block = blocksFor(args.mount)[0], binding;
    block.setAttribute('data-sc-case-bound', '');
    try { binding = root.ScCaseSelector.prepare(args); } catch (error) { block.removeAttribute('data-sc-case-bound'); throw error; }
    if (!binding) { block.removeAttribute('data-sc-case-bound'); throw new Error('Case selection unavailable'); }
    // The existing sidecar clears/hides only its certified legacy native add-on.
    binding.ownsNativeAddons = true;
    return binding;
  }

  registry['case-selector'] = { pending: pending, ready: ready, prepare: prepare };
  document.addEventListener('sc:case-change', function () { emit('pz:plugin-change'); });
  document.addEventListener('sc:case-assets-ready', function () { emit('pz:plugin-ready'); });
  // Also support an intentionally late module load while the generic host is waiting.
  emit('pz:plugin-ready');
  emit('pz:plugin-change');
}(typeof self !== 'undefined' ? self : this));
